import React from 'react';
import '../styles/skeletons.css';

export const CarouselSkeleton = () => (
    <div className="carousel-skeleton">
        {[1, 2, 3, 4].map(i => (
            <div key={i} className="skeleton-slide"></div>
        ))}
    </div>
);

export const CategorySkeleton = () => (
    <div className="categories-skeleton">
        {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className="category-skeleton-item animate-pulse">
                <div className="skeleton-icon"></div>
                <div className="skeleton-text"></div>
            </div>
        ))}
    </div>
);
export const UserSkeleton = () => (
    <div className="user-details-skeleton">
        <div className="profile-picture-skeleton"></div>
        <div className="user-info-skeleton">
            <div className="name-skeleton"></div>
            <div className="stats-skeleton"></div>
            <div className="details-skeleton">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div key={i} className="detail-line-skeleton"></div>
                ))}
            </div>
        </div>
    </div>
);
export const ProfileSkeleton = () => (
    <div className="profile-skeleton">
        <div className="profile-picture-skeleton animate-pulse"></div>
        <div className="profile-fields-skeleton">
            {[1, 2, 3, 4, 5, 6].map((_, index) => (
                <div key={index} className="profile-field-skeleton animate-pulse">
                    <div className="skeleton-label"></div>
                    <div className="skeleton-input"></div>
                </div>
            ))}
        </div>
        <div className="profile-buttons-skeleton">
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
        </div>
    </div>
);

export const UserNotificationsSkeleton = () => (
    <div className="user-notifications-skeleton">
        {[1, 2, 3, 4, 5].map((_, index) => (
            <div key={index} className="notification-skeleton-item animate-pulse">
                <div className="skeleton-dot"></div>
                <div className="skeleton-content">
                    <div className="skeleton-message"></div>
                    <div className="skeleton-time"></div>
                </div>
                <div className="skeleton-button"></div>
            </div>
        ))}
    </div>
);
export const UserConnectionsSkeleton = () => (
    <div className="connections-skeleton">
        {[1, 2, 3, 4, 5].map((_, index) => (
            <div key={index} className="connection-skeleton-item animate-pulse">
                <div className="skeleton-avatar"></div>
                <div className="skeleton-content">
                    <div className="skeleton-name"></div>
                    <div className="skeleton-username"></div>
                </div>
                <div className="skeleton-button"></div>
            </div>
        ))}
    </div>
);
export const PosterSlideshowSkeleton = () => (
    <div className="poster-slideshow-skeleton">
        <div className="skeleton-slide animate-pulse"></div>
        <div className="skeleton-indicators">
            {[1, 2, 3].map((_, index) => (
                <div key={index} className="skeleton-indicator animate-pulse"></div>
            ))}
        </div>
    </div>
);
export const ProductGridSkeleton = () => {
    return (
        <div className="products-grid-v2-skeleton">
            {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="product-skeleton-item-v2">
                    <div className="product-skeleton-image-section">
                        <div className="skeleton-image-v2 skeleton-shimmer"></div>
                        <div className="skeleton-price-overlay skeleton-shimmer">
                            <div className="skeleton-price-text skeleton-shimmer"></div>
                        </div>
                        <div className="skeleton-condition-badge skeleton-shimmer"></div>
                        {i % 3 === 0 && (
                            <div className="skeleton-promoted-badge skeleton-shimmer">
                                <div className="skeleton-crown-icon skeleton-shimmer"></div>
                                <div className="skeleton-promoted-text skeleton-shimmer"></div>
                            </div>
                        )}
                    </div>
                    <div className="product-skeleton-content-v2">
                        <div className="skeleton-title-v2 skeleton-shimmer"></div>
                        <div className="skeleton-description-v2">
                            <div className="skeleton-description-line-1 skeleton-shimmer"></div>
                            <div className="skeleton-description-line-2 skeleton-shimmer"></div>
                            <div className="skeleton-description-line-3 skeleton-shimmer"></div>
                        </div>
                        <div className="product-skeleton-meta-v2">
                            <div className="skeleton-location-category">
                                <div className="skeleton-location-v2">
                                    <div className="skeleton-location-icon skeleton-shimmer"></div>
                                    <div className="skeleton-location-text skeleton-shimmer"></div>
                                </div>
                                <div className="skeleton-category-v2">
                                    <div className="skeleton-category-icon skeleton-shimmer"></div>
                                    <div className="skeleton-category-text skeleton-shimmer"></div>
                                </div>
                            </div>
                            <div className="skeleton-stats-v2">
                                <div className="skeleton-likes-v2">
                                    <div className="skeleton-heart-icon skeleton-shimmer"></div>
                                    <div className="skeleton-likes-count skeleton-shimmer"></div>
                                </div>
                                <div className="skeleton-views-v2">
                                    <div className="skeleton-eye-icon skeleton-shimmer"></div>
                                    <div className="skeleton-views-count skeleton-shimmer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

// Load More Skeleton - shows when user clicks "Load More" or during pagination
export const LoadMoreSkeleton = ({ count = 4 }) => {
    return (
        <div className="load-more-skeleton">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="product-skeleton-item-v2 load-more-skeleton-item">
                    <div className="product-skeleton-image-section">
                        <div className="skeleton-image-v2"></div>
                        
                        {/* Price Overlay */}
                        <div className="skeleton-price-overlay">
                            <div className="skeleton-price-text"></div>
                        </div>

                        {/* Condition Badge */}
                        <div className="skeleton-condition-badge"></div>

                        {/* Promoted Badge (randomly show on some items) */}
                        {i % 3 === 0 && (
                            <div className="skeleton-promoted-badge">
                                <div className="skeleton-crown-icon"></div>
                                <div className="skeleton-promoted-text"></div>
                            </div>
                        )}
                    </div>

                    {/* Content Section */}
                    <div className="product-skeleton-content-v2">
                        {/* Product Name */}
                        <div className="skeleton-title-v2"></div>
                        
                        {/* Product Description */}
                        <div className="skeleton-description-v2">
                            <div className="skeleton-description-line-1"></div>
                            <div className="skeleton-description-line-2"></div>
                            <div className="skeleton-description-line-3"></div>
                        </div>

                        {/* Meta Section */}
                        <div className="product-skeleton-meta-v2">
                            {/* Location and Category */}
                            <div className="skeleton-location-category">
                                <div className="skeleton-location-v2">
                                    <div className="skeleton-location-icon"></div>
                                    <div className="skeleton-location-text"></div>
                                </div>
                                <div className="skeleton-category-v2">
                                    <div className="skeleton-category-icon"></div>
                                    <div className="skeleton-category-text"></div>
                                </div>
                            </div>

                            {/* Stats */}
                            <div className="skeleton-stats-v2">
                                <div className="skeleton-likes-v2">
                                    <div className="skeleton-heart-icon"></div>
                                    <div className="skeleton-likes-count"></div>
                                </div>
                                <div className="skeleton-views-v2">
                                    <div className="skeleton-eye-icon"></div>
                                    <div className="skeleton-views-count"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
export const RatingsSkeleton = () => (
    <div className="ratings-skeleton">
        {[1, 2, 3].map((_, index) => (
            <div key={index} className="rating-skeleton-item animate-pulse">
                <div className="skeleton-avatar"></div>
                <div className="skeleton-text"></div>
                <div className="skeleton-comment"></div>
            </div>
        ))}
    </div>
);

export const ProductDetailsSkeleton = () => (
    <div className="product-details-skeleton">
        <div className="product-content-skeleton">
            {/* Media Section Skeleton */}
            <div className="product-media-skeleton">
                <div className="skeleton-slideshow">
                    <div className="skeleton-main-image skeleton-shimmer"></div>
                    <div className="skeleton-thumbnail-list">
                        {[1, 2, 3, 4, 5].map(i => (
                            <div key={i} className="skeleton-thumbnail skeleton-shimmer"></div>
                        ))}
                    </div>
                </div>
                
                {/* Product Info Header */}
                <div className="skeleton-product-header">
                    <div className="skeleton-product-title-main skeleton-shimmer"></div>
                    <div className="skeleton-product-price-main skeleton-shimmer"></div>
                    <div className="skeleton-product-condition skeleton-shimmer"></div>
                </div>

                {/* Likes and Views Section */}
                <div className="skeleton-interactions">
                    <div className="skeleton-likes">
                        <div className="skeleton-icon skeleton-shimmer"></div>
                        <div className="skeleton-count skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-views">
                        <div className="skeleton-icon skeleton-shimmer"></div>
                        <div className="skeleton-count skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-share">
                        <div className="skeleton-icon skeleton-shimmer"></div>
                        <div className="skeleton-icon skeleton-shimmer"></div>
                    </div>
                </div>

                {/* Product Description */}
                <div className="skeleton-description-section">
                    <div className="skeleton-description-title skeleton-shimmer"></div>
                    <div className="skeleton-description-lines">
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} className="skeleton-description-line skeleton-shimmer" style={{width: i === 4 ? '60%' : '100%'}}></div>
                        ))}
                    </div>
                </div>
            </div>

            {/* User Details Section Skeleton */}
            <div className="user-content-skeleton">
                <div className="user-details-card-skeleton">
                    {/* Profile Section */}
                    <div className="profile-section-skeleton">
                        <div className="profile-picture-skeleton skeleton-shimmer"></div>
                        <div className="names-skeleton">
                            <div className="skeleton-name skeleton-shimmer"></div>
                            <div className="skeleton-stats skeleton-shimmer"></div>
                            <div className="skeleton-rating">
                                {[1, 2, 3, 4, 5].map(i => (
                                    <div key={i} className="skeleton-star skeleton-shimmer"></div>
                                ))}
                            </div>
                        </div>
                    </div>
                    
                    {/* Owner Info */}
                    <div className="owner-info-skeleton">
                        <div className="skeleton-info-title skeleton-shimmer"></div>
                        {[1, 2, 3, 4, 5].map(i => (
                            <div key={i} className="owner-info-item-skeleton">
                                <div className="skeleton-label skeleton-shimmer"></div>
                                <div className="skeleton-value skeleton-shimmer"></div>
                            </div>
                        ))}
                    </div>

                    {/* Social Links */}
                    <div className="skeleton-social-links">
                        {[1, 2, 3].map(i => (
                            <div key={i} className="skeleton-social-link skeleton-shimmer"></div>
                        ))}
                    </div>

                    {/* Action Buttons */}
                    <div className="product-actions-skeleton">
                        <div className="skeleton-button primary skeleton-shimmer"></div>
                        <div className="skeleton-button secondary skeleton-shimmer"></div>
                    </div>
                </div>
            </div>
        </div>

        {/* Product Specifications */}
        <div className="specification-skeleton">
            <div className="skeleton-section-title skeleton-shimmer"></div>
            <div className="skeleton-specification-grid">
                {[1, 2, 3, 4, 5, 6].map(i => (
                    <div key={i} className="skeleton-spec-item">
                        <div className="skeleton-spec-label skeleton-shimmer"></div>
                        <div className="skeleton-spec-value skeleton-shimmer"></div>
                    </div>
                ))}
            </div>
        </div>

        {/* Related Products Section */}
        <div className="related-products-skeleton">
            <div className="skeleton-section-title skeleton-shimmer"></div>
            <div className="skeleton-products-grid">
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="skeleton-product-card">
                        <div className="skeleton-product-image skeleton-shimmer"></div>
                        <div className="skeleton-product-details">
                            <div className="skeleton-product-price skeleton-shimmer"></div>
                            <div className="skeleton-product-title skeleton-shimmer"></div>
                            <div className="skeleton-product-location skeleton-shimmer"></div>
                            <div className="skeleton-product-meta">
                                <div className="skeleton-product-likes skeleton-shimmer"></div>
                                <div className="skeleton-product-views skeleton-shimmer"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>

        {/* Owner's Other Products Section */}
        <div className="owner-products-skeleton">
            <div className="skeleton-section-title skeleton-shimmer"></div>
            <div className="skeleton-products-grid">
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="skeleton-product-card">
                        <div className="skeleton-product-image skeleton-shimmer"></div>
                        <div className="skeleton-product-details">
                            <div className="skeleton-product-price skeleton-shimmer"></div>
                            <div className="skeleton-product-title skeleton-shimmer"></div>
                            <div className="skeleton-product-location skeleton-shimmer"></div>
                            <div className="skeleton-product-meta">
                                <div className="skeleton-product-likes skeleton-shimmer"></div>
                                <div className="skeleton-product-views skeleton-shimmer"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export const UserDetailsSkeleton = () => (
    <div className="user-details-skeleton">
        <div className="skeleton-avatar skeleton-shimmer"></div>
        <div className="skeleton-name skeleton-shimmer"></div>
        <div className="skeleton-info skeleton-shimmer"></div>
    </div>
);
export const NotificationSkeleton = () => (
    <div className="notifications-skeleton">
        {[1, 2, 3, 4, 5].map((_, index) => (
            <div key={index} className="notification-skeleton-item animate-pulse">
                <div className="skeleton-dot"></div>
                <div className="skeleton-content">
                    <div className="skeleton-message"></div>
                    <div className="skeleton-time"></div>
                </div>
            </div>
        ))}
    </div>
);

export const FormSkeleton = () => (
    <div className="form-skeleton">
        {[1, 2, 3, 4, 5].map((_, index) => (
            <div key={index} className="form-skeleton-item animate-pulse">
                <div className="skeleton-label"></div>
                <div className="skeleton-input"></div>
            </div>
        ))}
    </div>
);

export const InboxSkeleton = () => (
    <div className="inbox-skeleton enhanced">
        {/* Header Skeleton */}
        <div className="inbox-header-skeleton enhanced animate-pulse">
            <div className="header-top-skeleton">
                <div className="skeleton-title large"></div>
                <div className="skeleton-filter-button"></div>
            </div>
            
            {/* Search Section Skeleton */}
            <div className="search-section-skeleton">
                <div className="search-input-skeleton animate-pulse">
                    <div className="search-icon-skeleton"></div>
                    <div className="search-placeholder-skeleton"></div>
                    <div className="clear-button-skeleton"></div>
                </div>
            </div>
        </div>

        {/* Tab Navigation Skeleton */}
        <div className="tab-navigation-skeleton animate-pulse">
            {[1, 2, 3, 4, 5].map((_, index) => (
                <div key={index} className="tab-button-skeleton">
                    <div className="tab-label-skeleton"></div>
                    <div className="tab-count-skeleton"></div>
                </div>
            ))}
        </div>

        {/* Message List Skeleton */}
        <div className="messages-list-skeleton">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => (
                <div key={index} className="message-item-skeleton enhanced animate-pulse">
                    <div className="message-card-skeleton">
                        <div className="avatar-skeleton"></div>
                        <div className="message-content-skeleton">
                            <div className="message-header-skeleton">
                                <div className="sender-name-skeleton"></div>
                            </div>
                            <div className="product-name-skeleton"></div>
                            <div className="message-info-skeleton">
                                <div className="username-skeleton"></div>
                                <div className="bullet-skeleton"></div>
                                <div className="message-count-skeleton"></div>
                            </div>
                        </div>
                        <div className="message-meta-skeleton">
                            <div className="date-skeleton"></div>
                            <div className="unread-count-skeleton"></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export const ChatRoomSkeleton = () => (
    <div className="chat-room-skeleton">
        <div className="chat-header-skeleton animate-pulse">
            <div className="skeleton-product-info">
                <div className="skeleton-title"></div>
                <div className="skeleton-price"></div>
            </div>
        </div>
        <div className="chat-messages-skeleton">
            {[1, 2, 3, 4].map((_, index) => (
                <div
                    key={index}
                    className={`chat-message-skeleton animate-pulse ${index % 2 === 0 ? 'left' : 'right'}`}
                >
                    <div className="message-user-info">
                        <div className="skeleton-avatar"></div>
                        <div className="skeleton-username"></div>
                    </div>
                    <div className="message-content-skeleton">
                        <div className="skeleton-text-long"></div>
                        <div className="skeleton-text-short"></div>
                    </div>
                    <div className="skeleton-timestamp"></div>
                </div>
            ))}
        </div>
        <div className="chat-input-skeleton animate-pulse">
            <div className="skeleton-input"></div>
            <div className="skeleton-button"></div>
        </div>
    </div>
);
export const TermsConditionsSkeleton = () => (
    <div className="register-container">
        <div className="register-card">
            {/* Header buttons skeleton */}
            <div className="terms-header-actions">
                <div className="skeleton-header-btn animate-pulse"></div>
                <div className="skeleton-header-btn animate-pulse"></div>
            </div>
            
            {/* Content skeleton */}
            <div className="terms-content">
                <div className="skeleton-title animate-pulse"></div>
                <div className="skeleton-date animate-pulse"></div>
                
                {/* Multiple sections */}
                {[1, 2, 3, 4, 5, 6].map((section) => (
                    <div key={section} className="skeleton-section">
                        <div className="skeleton-section-title animate-pulse"></div>
                        {[1, 2, 3].map((para) => (
                            <div key={para} className="skeleton-paragraph-container">
                                <div className="skeleton-paragraph animate-pulse"></div>
                                <div className="skeleton-paragraph animate-pulse" style={{width: '85%'}}></div>
                                <div className="skeleton-paragraph animate-pulse" style={{width: '92%'}}></div>
                            </div>
                        ))}
                        
                        {/* Bullet points skeleton */}
                        <div className="skeleton-list">
                            {[1, 2, 3, 4].map((item) => (
                                <div key={item} className="skeleton-list-item animate-pulse"></div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            
            {/* Bottom action skeleton */}
            <div className="terms-bottom-actions">
                <div className="skeleton-back-button animate-pulse"></div>
            </div>
        </div>
    </div>
);

// Infinity Loading Skeleton that matches the Product Grid Skeleton
export const InfinityLoadingSkeleton = () => (
    <div className="products-grid-v2-skeleton infinity-loading-skeleton">
        {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="product-skeleton-item-v2">
                <div className="product-skeleton-image-section">
                    <div className="skeleton-image-v2 skeleton-shimmer"></div>
                    <div className="skeleton-price-overlay skeleton-shimmer">
                        <div className="skeleton-price-text skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-condition-badge skeleton-shimmer"></div>
                    {i % 3 === 0 && (
                        <div className="skeleton-promoted-badge skeleton-shimmer">
                            <div className="skeleton-crown-icon skeleton-shimmer"></div>
                            <div className="skeleton-promoted-text skeleton-shimmer"></div>
                        </div>
                    )}
                </div>
                <div className="product-skeleton-content-v2">
                    <div className="skeleton-title-v2 skeleton-shimmer"></div>
                    <div className="skeleton-description-v2">
                        <div className="skeleton-description-line-1 skeleton-shimmer"></div>
                        <div className="skeleton-description-line-2 skeleton-shimmer"></div>
                        <div className="skeleton-description-line-3 skeleton-shimmer"></div>
                    </div>
                    <div className="product-skeleton-meta-v2">
                        <div className="skeleton-location-category">
                            <div className="skeleton-location-v2">
                                <div className="skeleton-location-icon skeleton-shimmer"></div>
                                <div className="skeleton-location-text skeleton-shimmer"></div>
                            </div>
                            <div className="skeleton-category-v2">
                                <div className="skeleton-category-icon skeleton-shimmer"></div>
                                <div className="skeleton-category-text skeleton-shimmer"></div>
                            </div>
                        </div>
                        <div className="skeleton-stats-v2">
                            <div className="skeleton-likes-v2">
                                <div className="skeleton-heart-icon skeleton-shimmer"></div>
                                <div className="skeleton-likes-count skeleton-shimmer"></div>
                            </div>
                            <div className="skeleton-views-v2">
                                <div className="skeleton-eye-icon skeleton-shimmer"></div>
                                <div className="skeleton-views-count skeleton-shimmer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>
);

// Search Results Page Skeleton
export const SearchResultsSkeleton = () => (
    <div className="search-results-skeleton">
        {/* Search Header Skeleton */}
        <div className="search-header-skeleton">
            <div className="search-title-skeleton skeleton-shimmer"></div>
            <div className="categories-container-skeleton">
                {[1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className="category-pill-skeleton skeleton-shimmer"></div>
                ))}
            </div>
        </div>

        {/* Search Results Content */}
        <div className="search-results-content-skeleton">
            <ProductGridSkeleton />
        </div>

        {/* Suggestions Section Skeleton */}
        <div className="suggestions-section-skeleton">
            <div className="section-title-skeleton skeleton-shimmer"></div>
            <ProductGridSkeleton />
        </div>
    </div>
);

// Search Results Loading State (when searching)
export const SearchLoadingSkeleton = ({ showCategories = true, showSuggestions = false }) => (
    <div className="search-loading-skeleton">
        {showCategories && (
            <div className="search-header-skeleton">
                <div className="search-title-skeleton skeleton-shimmer"></div>
                <div className="categories-container-skeleton">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="category-pill-skeleton skeleton-shimmer"></div>
                    ))}
                </div>
            </div>
        )}

        {/* Searching indicator */}
        <div className="searching-indicator">
            <div className="searching-spinner"></div>
            <div className="searching-text">Recherche en cours...</div>
        </div>

        {/* Show partial skeleton while searching */}
        <div className="search-partial-skeleton">
            <ProductGridSkeleton />
        </div>

        {showSuggestions && (
            <div className="suggestions-section-skeleton">
                <div className="section-title-skeleton skeleton-shimmer"></div>
                <div className="suggestions-grid-skeleton">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="product-skeleton-item-v2">
                            <div className="product-skeleton-image-section">
                                <div className="skeleton-image-v2 skeleton-shimmer"></div>
                            </div>
                            <div className="product-skeleton-content-v2">
                                <div className="skeleton-title-v2 skeleton-shimmer"></div>
                                <div className="skeleton-description-v2">
                                    <div className="skeleton-description-line-1 skeleton-shimmer"></div>
                                    <div className="skeleton-description-line-2 skeleton-shimmer"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )}
    </div>
);
export const WalletSkeleton = () => (
    <div className="wallet-skeleton">
        {/* Header skeleton */}
        <div className="wallet-header-skeleton">
            <div className="wallet-title-skeleton animate-pulse">
                <div className="wallet-icon-skeleton"></div>
                <div className="title-text-skeleton"></div>
            </div>
            <div className="description-skeleton animate-pulse"></div>
        </div>

        {/* Balance card skeleton */}
        <div className="wallet-balance-skeleton animate-pulse">
            <div className="balance-info-skeleton">
                <div className="balance-label-skeleton"></div>
                <div className="balance-amount-skeleton"></div>
                <div className="balance-updated-skeleton"></div>
            </div>
            <div className="balance-actions-skeleton">
                <div className="promote-button-skeleton"></div>
            </div>
        </div>

        {/* Active promotions skeleton */}
        <div className="active-promotions-skeleton">
            <div className="section-title-skeleton animate-pulse"></div>
            <div className="promotions-grid-skeleton">
                {[1, 2].map(i => (
                    <div key={i} className="promotion-card-skeleton animate-pulse">
                        <div className="promotion-type-skeleton"></div>
                        <div className="promotion-product-skeleton"></div>
                        <div className="promotion-dates-skeleton"></div>
                    </div>
                ))}
            </div>
        </div>

        {/* Prices section skeleton */}
        <div className="zaire-prices-skeleton">
            <div className="section-title-skeleton animate-pulse"></div>
            <div className="prices-grid-skeleton">
                {[1, 2, 3].map(i => (
                    <div key={i} className="price-card-skeleton animate-pulse">
                        <div className="price-title-skeleton"></div>
                        <div className="price-amount-skeleton"></div>
                        <div className="price-duration-skeleton"></div>
                    </div>
                ))}
            </div>
        </div>

        {/* Transactions section skeleton */}
        <div className="transactions-skeleton">
            <div className="transactions-header-skeleton">
                <div className="section-title-skeleton animate-pulse"></div>
                <div className="transaction-controls-skeleton">
                    <div className="filter-control-skeleton animate-pulse"></div>
                    <div className="date-filter-skeleton animate-pulse"></div>
                    <div className="sort-button-skeleton animate-pulse"></div>
                </div>
            </div>

            <div className="transactions-table-skeleton">
                <div className="table-header-skeleton animate-pulse">
                    {['Type', 'Date', 'Description', 'Montant', 'Solde'].map((header, i) => (
                        <div key={i} className="table-header-cell-skeleton"></div>
                    ))}
                </div>
                <div className="table-body-skeleton">
                    {[1, 2, 3, 4, 5].map(i => (
                        <div key={i} className="transaction-row-skeleton animate-pulse">
                            <div className="transaction-type-skeleton"></div>
                            <div className="transaction-date-skeleton"></div>
                            <div className="transaction-desc-skeleton"></div>
                            <div className="transaction-amount-skeleton"></div>
                            <div className="transaction-balance-skeleton"></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
);

// Side Menu Category Loading Skeleton
export const SideMenuCategorySkeleton = () => (
    <ul className="subcategory-list">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <li key={i} className="category-item skeleton-item">
                <div className="category-skeleton-content animate-pulse">
                    <div className="skeleton-category-text"></div>
                    <div className="skeleton-category-arrow"></div>
                </div>
            </li>
        ))}
    </ul>
);

// SMS Message List Skeleton
export const MessageListSkeleton = () => (
    <div className="message-list-skeleton">
        {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="message-card-skeleton animate-pulse">
                <div className="skeleton-message-header">
                    <div className="skeleton-status-badge"></div>
                    <div className="skeleton-date"></div>
                </div>
                <div className="skeleton-message-content"></div>
                <div className="skeleton-message-stats">
                    <div className="skeleton-stat"></div>
                    <div className="skeleton-stat"></div>
                    <div className="skeleton-stat"></div>
                </div>
                <div className="skeleton-progress-bar"></div>
            </div>
        ))}
    </div>
);

// SMS Message Detail Skeleton
export const MessageDetailSkeleton = () => (
    <div className="message-detail-skeleton">
        <div className="skeleton-detail-header animate-pulse">
            <div className="skeleton-back-button"></div>
            <div className="skeleton-title"></div>
            <div className="skeleton-refresh-button"></div>
        </div>
        <div className="skeleton-status-card animate-pulse">
            <div className="skeleton-status-badge-large"></div>
            <div className="skeleton-message-preview"></div>
        </div>
        <div className="skeleton-stats-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="skeleton-stat-card animate-pulse">
                    <div className="skeleton-stat-icon"></div>
                    <div className="skeleton-stat-label"></div>
                    <div className="skeleton-stat-value"></div>
                </div>
            ))}
        </div>
        <div className="skeleton-delivery-rate animate-pulse">
            <div className="skeleton-rate-label"></div>
            <div className="skeleton-rate-bar"></div>
        </div>
        <div className="skeleton-recipients-list">
            {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="skeleton-recipient-card animate-pulse">
                    <div className="skeleton-recipient-avatar"></div>
                    <div className="skeleton-recipient-info">
                        <div className="skeleton-recipient-name"></div>
                        <div className="skeleton-recipient-phone"></div>
                    </div>
                    <div className="skeleton-recipient-status"></div>
                </div>
            ))}
        </div>
    </div>
);

// Boost Product Skeleton
export const BoostProductSkeleton = () => (
    <div className="boost-product-skeleton">
        <div className="skeleton-boost-header animate-pulse">
            <div className="skeleton-boost-icon"></div>
            <div className="skeleton-boost-title"></div>
        </div>
        <div className="skeleton-boost-product-preview animate-pulse">
            <div className="skeleton-boost-image"></div>
            <div className="skeleton-boost-product-info">
                <div className="skeleton-boost-product-name"></div>
                <div className="skeleton-boost-product-price"></div>
                <div className="skeleton-boost-product-status"></div>
            </div>
        </div>
        <div className="skeleton-boost-options">
            {[1, 2, 3].map((i) => (
                <div key={i} className="skeleton-boost-option-card animate-pulse">
                    <div className="skeleton-boost-option-header"></div>
                    <div className="skeleton-boost-option-price"></div>
                    <div className="skeleton-boost-option-features"></div>
                    <div className="skeleton-boost-option-button"></div>
                </div>
            ))}
        </div>
    </div>
);

// Promote Product Skeleton
export const PromoteProductSkeleton = () => (
    <div className="promote-product-skeleton">
        <div className="skeleton-promote-header animate-pulse">
            <div className="skeleton-promote-back-button"></div>
            <div className="skeleton-promote-title"></div>
        </div>
        <div className="skeleton-promote-product-info animate-pulse">
            <div className="skeleton-promote-image"></div>
            <div className="skeleton-promote-details">
                <div className="skeleton-promote-name"></div>
                <div className="skeleton-promote-price"></div>
            </div>
        </div>
        <div className="skeleton-promote-form">
            <div className="skeleton-form-group animate-pulse">
                <div className="skeleton-form-label"></div>
                <div className="skeleton-form-input"></div>
            </div>
            <div className="skeleton-form-group animate-pulse">
                <div className="skeleton-form-label"></div>
                <div className="skeleton-form-input"></div>
            </div>
            <div className="skeleton-form-group animate-pulse">
                <div className="skeleton-form-label"></div>
                <div className="skeleton-form-select"></div>
            </div>
        </div>
        <div className="skeleton-promote-summary animate-pulse">
            <div className="skeleton-summary-item"></div>
            <div className="skeleton-summary-item"></div>
            <div className="skeleton-summary-total"></div>
        </div>
        <div className="skeleton-promote-button animate-pulse"></div>
    </div>
);